import { createAsyncThunk } from '@reduxjs/toolkit';

import { journeyAPI } from '@/modules/journey/api';
import { namespace } from '@/modules/journey/namespace';

import { setJourney } from '../actions';

const loadJourney = createAsyncThunk(
  `${namespace}/load-journey`,
  async ({ id }: { id: string }, { dispatch }) => {
    const journey = await journeyAPI.fetchJourney(id);

    dispatch(setJourney(journey));

    return journey;
  },
);

export { loadJourney };
